import { ArrowUpRight } from "@phosphor-icons/react";
import { useFetch } from "../lib/useFetch";

export const Nyheder = () => {
  const { data: news } = useFetch("/news");
  if (news.length === 0) return null;
  const featured = news.find((n) => n.featured) || news[0];
  const rest = news.filter((n) => n.id !== featured.id);

  return (
    <section
      id="nyheder"
      data-testid="nyheder-section"
      className="border-t border-neutral-900 bg-[#0A0A0A] py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="section-eyebrow">05 · Klubben lige nu</span>
            <h2 className="mt-5 font-heading text-5xl uppercase leading-none tracking-tight text-white sm:text-6xl lg:text-7xl">
              Nyheder
            </h2>
          </div>
          <a
            href="https://www.taastrupfc.com/nyheder/tfc-nyheder/2026/"
            target="_blank"
            rel="noreferrer"
            className="btn-ghost self-start text-xs md:self-auto"
            data-testid="nyheder-view-all"
          >
            Alle opdateringer <ArrowUpRight size={14} />
          </a>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-6 lg:grid-rows-2">
          <a
            href={featured.href || "#"}
            target={featured.href ? "_blank" : undefined}
            rel="noreferrer"
            data-testid={`news-card-${featured.id}`}
            className="group relative overflow-hidden border border-neutral-800 lg:col-span-4 lg:row-span-2"
          >
            {featured.image && (
              <img
                src={featured.image}
                alt={featured.title}
                className="h-full max-h-[560px] w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />
            <div className="absolute left-0 right-0 bottom-0 p-6 lg:p-10">
              <span className="mono-label bg-brand px-2 py-1 text-black">
                {featured.category}
              </span>
              <h3 className="mt-4 font-heading text-3xl uppercase leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
                {featured.title}
              </h3>
              <p className="mt-3 max-w-2xl font-body text-sm text-neutral-300 sm:text-base">
                {featured.excerpt}
              </p>
              <div className="mono-label mt-5 flex items-center gap-3 text-neutral-400">
                {featured.date}
                <span className="inline-flex items-center gap-1 text-brand opacity-0 transition-opacity group-hover:opacity-100">
                  Læs mere <ArrowUpRight size={14} />
                </span>
              </div>
            </div>
          </a>

          {rest.slice(0, 3).map((n) => (
            <a
              key={n.id}
              href={n.href || "#"}
              target={n.href ? "_blank" : undefined}
              rel="noreferrer"
              data-testid={`news-card-${n.id}`}
              className="group relative flex flex-col overflow-hidden border border-neutral-800 bg-neutral-950 transition-colors hover:border-brand lg:col-span-2"
            >
              {n.image && (
                <div className="h-40 overflow-hidden">
                  <img
                    src={n.image}
                    alt={n.title}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
              )}
              <div className="flex flex-1 flex-col p-5">
                <span className="mono-label text-brand">{n.category}</span>
                <h3 className="mt-2 font-heading text-xl uppercase leading-tight tracking-tight text-white">
                  {n.title}
                </h3>
                <p className="mt-2 line-clamp-2 font-body text-sm text-neutral-400">
                  {n.excerpt}
                </p>
                <div className="mono-label mt-4 flex items-center justify-between text-neutral-500">
                  <span>{n.date}</span>
                  <ArrowUpRight
                    size={14}
                    className="text-neutral-500 transition-colors group-hover:text-brand"
                  />
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
